import baseAPI from './axiosApi'

const api={
    list:'/api-ir/hr/assess/list',
    info:'/api-ir/hr/assess/',
    add:'/api-ir/hr/assess',
    update:'/api-ir/hr/assess',
    del:'/api-ir/hr/assess/',
    complaintList:'/api-ir/hr/assess/complaint/',
    complaint:'/api-ir/hr/assess/complaint',
    replied:'/api-ir/hr/assess/replied',
    standard:'/api-ir/hr/assess/standard/',
    confirm:'/api-ir/hr/assess/confirm/',
    cancel:'/api-ir/hr/assess/cancel/',
    exportExcel:'/api-ir/hr/assess/export'
}

export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

export function info (data) {
    return baseAPI.axiosData(api.info+data,'get',null)
}

export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}

export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}

export function del (data) {
    return baseAPI.axiosData(api.info+data,'delete',null)
}

export function complaintList (data) {
    return baseAPI.axiosData(api.complaintList+data,'get',null)
}

export function complaint (data) {
    return baseAPI.axiosData(api.complaint,'post',data)
}

export function replied (data) {
    return baseAPI.axiosData(api.replied,'post',data)
}

export function standard (teacherId,schoolYear) {
    return baseAPI.axiosData(api.standard+teacherId+'/'+schoolYear,'get',null)
}

export function confirm (teacherId,schoolYear) {
    return baseAPI.axiosData(api.confirm+teacherId+'/'+schoolYear,'post',null)
}

export function cancel (teacherId,schoolYear) {
    return baseAPI.axiosData(api.cancel+teacherId+'/'+schoolYear,'post',null)
}

export function exportExcel (data) {
    return baseAPI.axiosData(api.exportExcel,'get',data)
}